import React, { Component } from 'react';
import { Col, Row, Card, CardBody, Button, Breadcrumb, BreadcrumbItem, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { connect } from 'react-redux';
import withAuth from '../../components/Services/WithAuth';
import { Link } from 'react-router-dom';
import { fetchBulkReportRequests, downloadBulkReportRequestTemplate, submitBulkReportRequest, downloadRecordRequestFile} from './action';
import TableView from './TableView/index';
import { toast } from 'react-toastify';
import fileSaver from 'file-saver';
import { Preloading } from '../../components/UI/Preloader/action';
import Modal from '../../components/UI/Modal/Modal'
import classnames from 'classnames';
import * as constant from './constant'

class BulkCaseRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            caseType : constant.DOMESTIC,
            tableLoading: false,
            tableFetchResponse: {},
            transactionFileDomestic: '',
            transactionFileInternational: '',
            noUploadWarningDomestic: '',
            noUploadWarningInternational: '',
            resizeZIndex: false,
            showFailureModal: false,
            failureMessageHeading: '',
            failureMessageBody: ''
        }
    }

    componentDidMount(){
        this.fetchTableRecords(constant.DEFUALT_FETCH_LIST_REQUEST)
    }

    componentDidUpdate(prevProps) {
        const {fetchBulkRequestsSuccess, fetchBulkRequestsFailure, downloadBulkReportRequestTemplateSuccess, downloadBulkReportRequestTemplateFailure, submitBulkReportRequestSuccess, submitBulkReportRequestFailure, downloadRecordRequestFileSuccess, downloadRecordRequestFileFailure} = this.props
        if (fetchBulkRequestsSuccess !== prevProps.fetchBulkRequestsSuccess) {
            this.setState({
                tableFetchResponse: fetchBulkRequestsSuccess,
                tableLoading: false
            })
        }
        if (fetchBulkRequestsFailure !== prevProps.fetchBulkRequestsFailure) {
            this.setState({tableLoading: false})
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occurred while fetching table
                </div>
            );

        }

        if (downloadBulkReportRequestTemplateSuccess !== prevProps.downloadBulkReportRequestTemplateSuccess) {
            this.props.preloading(false)
            var blob = new Blob([downloadBulkReportRequestTemplateSuccess], { type: 'application/octet-stream' });
            fileSaver.saveAs(blob, `Bulk_${this.state.caseType.toLowerCase()}_report_request_template.xlsx`);
        }
        if (downloadBulkReportRequestTemplateFailure !== prevProps.downloadBulkReportRequestTemplateFailure) {
            this.props.preloading(false)
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br/>&nbsp;Please try again!
                </div>
            );
        }


        if (submitBulkReportRequestSuccess !== prevProps.submitBulkReportRequestSuccess) {
            this.props.preloading(false)

            if(submitBulkReportRequestSuccess.validationFailureReason) { //on validation failure
                let errorMessage = ''
                if(submitBulkReportRequestSuccess.errorCellsOfColumn.length > 0 ) { 
                    submitBulkReportRequestSuccess.errorCellsOfColumn.forEach(element => {
                        element.rows.forEach(elem => {
                            let tempString = `Column: ${element.column} \t\tRow no.: ${elem}\n`;
                            errorMessage += tempString;
                        });
                    });
                }
                this.setState({
                    showFailureModal: true,
                    failureMessageHeading: submitBulkReportRequestSuccess.validationFailureReason,
                    failureMessageBody: errorMessage
                })
            }

            else{                               //on validation success
                if(this.state.caseType === constant.DOMESTIC) {
                    this.setState({
                        noUploadWarningDomestic: '',
                        transactionFileDomestic: ''
                    })
                }
                else{
                    this.setState({
                        noUploadWarningInternational: '',
                        transactionFileInternational: ''
                    })
                }
                toast.success(
                    <div>
                        <i className="fa fa-check-circle fa-lg"></i>&nbsp;Submitted Succesfully!
                    </div>
                );
                this.fetchTableRecords({caseType: this.state.caseType,
                                        pageNumber: 0,
                                        pageSize: 10,
                                        sortField: 'createdAt',
                                        sortDirection: 'desc' })
            }
        }


        if (submitBulkReportRequestFailure !== prevProps.submitBulkReportRequestFailure) {
            this.props.preloading(false)
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Something went wrong!<br/>&nbsp;Please try again!
                </div>
            );
            
        }

        if (downloadRecordRequestFileSuccess !== prevProps.downloadRecordRequestFileSuccess) {
            this.props.preloading(false)
            window.open(downloadRecordRequestFileSuccess);
        }
        if (downloadRecordRequestFileFailure !== prevProps.downloadRecordRequestFileFailure) {
            this.props.preloading(false)
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br/>&nbsp;Please try again!
                </div>
            );
        }

    }

    toggle = (tab) => {
        if (this.state.caseType !== tab) {
          this.setState({
            tableLoading: true,
            caseType: tab
          }, () => {
            this.fetchTableRecords({caseType: tab,
                                    pageNumber: 0,
                                    pageSize: 10,
                                    sortField: 'createdAt',
                                    sortDirection: 'desc' })
          });
        }
      }

    fetchTableRecords = (caseTypeAndPageInfo) => {
        this.setState({tableLoading: true})
        this.props.fetchBulkReportRequests(caseTypeAndPageInfo)
    }

    handleTemplateDownload = () => {
        this.props.preloading(true)
        this.props.downloadBulkReportRequestTemplate({caseType: this.state.caseType})
    }

    uploadExcel = (event) => {
        if(this.state.caseType === constant.DOMESTIC) {
            this.setState({
                transactionFileDomestic: event.target.files[0]
            })    
        }
        else{
            this.setState({
                transactionFileInternational: event.target.files[0]
            })
        }
        event.preventDefault();
        event.target.value = null;
    }

    handleSubmit = () => {

        if(this.state.caseType === constant.DOMESTIC) {
            if(!this.state.transactionFileDomestic) {
                this.setState({ noUploadWarningDomestic: constant.NOT_UPLOAD_WARNING})
            }
            else{
            this.props.submitBulkReportRequest({ caseType: this.state.caseType, 
                                                 file: this.state.transactionFileDomestic});
            this.props.preloading(true);
            }
        }
        else{
            if(!this.state.transactionFileInternational) {
                this.setState({ noUploadWarningInternational: constant.NOT_UPLOAD_WARNING})
            }
            else{
            this.props.submitBulkReportRequest({ caseType: this.state.caseType, 
                                                 file: this.state.transactionFileInternational});
            this.props.preloading(true);
            }
        }

    }

    handleCloseModal = () => {
        this.setState({
            showFailureModal:false
        })
    }

    handleDownloadRecordRequestFile = (record) => {
        this.props.preloading(true)
        this.props.downloadRecordRequestFile(record.fileKey)
    }

    render() {
        return (
            <Col>
                <Breadcrumb className="mb-3">
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Bulk Report Request</BreadcrumbItem>
                </Breadcrumb>
                <Card>
                    <CardBody>
                        <Nav tabs>
                            <NavItem>
                                <NavLink href="#"
                                    className={classnames({ active: this.state.caseType === constant.DOMESTIC })}
                                    onClick={() => { this.toggle(constant.DOMESTIC); }}>
                                    <span className='navig'>Domestic</span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#"
                                    className={classnames({ active: this.state.caseType === constant.INTERNATIONAL })}
                                    onClick={() => { this.toggle(constant.INTERNATIONAL); }}>
                                    <span className='navig'>International</span>
                                </NavLink>
                            </NavItem>
                        </Nav>

                        <TabContent activeTab={this.state.caseType}>

                            <TabPane tabId={constant.DOMESTIC}>
                                <Row>
                                    <Col sm='6' className="upload-bulk-request">
                                        <Row className="ml-0">
                                            <Button color="primary" onClick={this.handleTemplateDownload} className="btn color-excel-download ">
                                                <i className="fa fa-file-excel-o fa-lg"></i>&nbsp;&nbsp;Download Request Template
                                            </Button> 
                                        </Row>
                                        
                                    </Col>
                                    
                                </Row>
                                <Row className="text-muted ml-1 mt-3">Upload Request Template</Row>
                                <Row className="mb-4">
                                    <Col sm='6'>
                                        <Row color="primary" className="btn btn-primary ml-0 position-relative upload-payment-data browse-files" title="Upload Request Template">
                                            <input onChange={this.uploadExcel} type="file" name="file" id="file" className="upload-file" title="Upload Request Template" />
                                            <i className="fa fa-paperclip color-888 rotate-90deg p-1 fa-lg" /> Browse File(s)
                                            
                                        </Row>
                                        <Row className={(this.state.transactionFileDomestic) ? "text-muted ml-1 transaction-file-name-text" : "text-danger ml-1 noUploadWarning-text" }>{(this.state.transactionFileDomestic) ? this.state.transactionFileDomestic.name : this.state.noUploadWarningDomestic}</Row>
                                    </Col>
                                    <Col sm='3' className='mt-1'>
                                            <Button color='primary' onClick={this.handleSubmit}>Submit</Button> 
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <div className="col">
                                        <TableView listAndNoOfPages={this.state.tableFetchResponse}
                                            loading={this.state.tableLoading}
                                            caseType = {constant.DOMESTIC}
                                            downloadOrignal={this.handleDownloadRecordRequestFile}
                                            onFetchPage={this.fetchTableRecords} />
                                    </div>
                                </Row>
                            </TabPane>

                            <TabPane tabId={constant.INTERNATIONAL}>
                                <Row>
                                    <Col sm='6' className="upload-bulk-request">
                                        <Row className="ml-0">
                                            <Button color="primary" onClick={this.handleTemplateDownload} className="btn color-excel-download ">
                                                <i className="fa fa-file-excel-o fa-lg"></i>&nbsp;&nbsp;Download Request Template
                                            </Button> 
                                        </Row>
                                        
                                    </Col>
                                    
                                </Row>
                                <Row className="text-muted ml-1 mt-3">Upload Request Template</Row>
                                <Row className="mb-4">
                                    <Col sm='6'>
                                        <Row color="primary" className="btn btn-primary ml-0 position-relative upload-payment-data browse-files" title="Upload Request Template">
                                            <input onChange={this.uploadExcel} type="file" name="file" id="file" className="upload-file" title="Upload Request Template" />
                                            <i className="fa fa-paperclip color-888 rotate-90deg p-1 fa-lg" /> Browse File(s)
                                            
                                        </Row>
                                        <Row className={(this.state.transactionFileInternational) ? "text-muted ml-1 transaction-file-name-text" : "text-danger ml-1 noUploadWarning-text" }>{(this.state.transactionFileInternational) ? this.state.transactionFileInternational.name : this.state.noUploadWarningInternational}</Row>
                                    </Col>
                                    <Col sm='3' className='mt-1'>
                                            <Button color='primary' onClick={this.handleSubmit}>Submit</Button> 
                                    </Col>
                                </Row>

                                <Row>
                                <div className="col">
                                    <TableView listAndNoOfPages={this.state.tableFetchResponse}
                                        loading={this.state.tableLoading}
                                        caseType = {constant.INTERNATIONAL}
                                        downloadOrignal={this.handleDownloadRecordRequestFile}
                                        showFailureReasonModal={this.handleDownloadFailedFile}
                                        onFetchPage={this.fetchTableRecords} />
                                </div>
                                </Row>
                            </TabPane>

                        </TabContent>

                    </CardBody>
                    <Modal show={this.state.showFailureModal} className={this.state.resizeZIndex ? 'z-index-zero Large-Modal modal-content' : 'Large-Modal modal-content'} modalClosed={this.closeIt} >
                        <div className="modal-header row pt-0">
                        <h5 className="text-danger"><i className="fa fa-exclamation-triangle">&nbsp;</i>Failure</h5>
                            <button type="button" onClick={this.handleCloseModal} className="close outline-none" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>  
                        </div>
                        <div className="modal-body">
                            <h5>{this.state.failureMessageHeading}</h5><br/>
                            <pre className='validation-error-text'>{this.state.failureMessageBody}</pre>
                            <Button color="info" onClick={this.handleCloseModal}>OK</Button>
                        </div>
                    </Modal>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    fetchBulkRequestsSuccess: state.CorporateBulkCaseRequestReducer.fetchBulkRequestsSuccess,
    fetchBulkRequestsFailure: state.CorporateBulkCaseRequestReducer.fetchBulkRequestsFailure,
    downloadBulkReportRequestTemplateSuccess: state.CorporateBulkCaseRequestReducer.downloadBulkReportRequestTemplateSuccess,
    downloadBulkReportRequestTemplateFailure: state.CorporateBulkCaseRequestReducer.downloadBulkReportRequestTemplateFailure,
    submitBulkReportRequestSuccess: state.CorporateBulkCaseRequestReducer.submitBulkReportRequestSuccess,
    submitBulkReportRequestFailure: state.CorporateBulkCaseRequestReducer.submitBulkReportRequestFailure,
    downloadRecordRequestFileSuccess: state.CorporateBulkCaseRequestReducer.downloadRecordRequestFileSuccess,
    downloadRecordRequestFileFailure: state.CorporateBulkCaseRequestReducer.downloadRecordRequestFileFailure
})

const mapDispatchToProps = (dispatch) => ({
    fetchBulkReportRequests: (data) => {dispatch(fetchBulkReportRequests(data))},
    downloadBulkReportRequestTemplate: (data) => {dispatch(downloadBulkReportRequestTemplate(data))},
    submitBulkReportRequest: (data) => {dispatch(submitBulkReportRequest(data))},
    downloadRecordRequestFile: (data) => {dispatch(downloadRecordRequestFile(data))},
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default BulkCaseRequest = withAuth(connect(
    mapStateToProps,
    mapDispatchToProps
)(BulkCaseRequest))